import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import forumApi, { type ForumCard } from "../../services/api/forum_api";
import { HOST_API } from "../../services/api";

/** ForumPageHeader (schema forum_page_header) API-аас ирээгүй үед fallback */
const DEFAULT_TITLE = "ГАМШГИЙН БЭЛЭН БАЙДЛАА ШАЛГАХ ХЯНАЛТЫН ХУУДАС";
const DEFAULT_DESCRIPTION =
  "Төрийн болон төрийн бус байгууллага, аж ахуйн нэгж байгууллага, хуулийн этгээд, иргэн бүр тогтмол хугацаанд байгууллагынхаа болоод өөрийнхөө аюулгүй байдлын үнэлгээг доорх хялбаршуулсан хяналтын хуудаснуудын тусламжтайгаар хийж хэвших шаардлагатай...";

/** Forum хуудас – API-аар гарчиг болон картуудыг татана (forum-page-header, questions) */
export const ForumPage = () => {
  const [header, setHeader] = useState<{ title: string; description: string } | null>(null);
  const [cards, setCards] = useState<ForumCard[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [headerRes, questionsRes] = await Promise.all([
          forumApi.getHeader(),
          forumApi.getQuestions(),
        ]);
        if (headerRes.data?.success && headerRes.data?.data) {
          setHeader(headerRes.data.data);
        }
        if (questionsRes.data?.success && Array.isArray(questionsRes.data?.data)) {
          setCards(questionsRes.data.data);
        }
      } catch {
        setHeader({ title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const title = header?.title?.trim() || DEFAULT_TITLE;
  const description = header?.description?.trim() || DEFAULT_DESCRIPTION;

  return (
    <div className="min-h-screen w-full flex flex-col items-center gap-8 p-4">
      {/* ForumPageHeader (forum_page_header): title, description */}
      <div className="max-w-[700px] flex flex-col items-center mt-4 gap-2 px-2">
        <p className="font-bold text-[18px] sm:text-[20px] text-center">
          {loading ? "..." : title}
        </p>
        <p className="text-center text-sm sm:text-base">
          {loading ? "..." : description}
        </p>
      </div>

      {/* Question (questions): id, title, link, image – идэвхтэй картууд */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1200px]">
        {cards.map((card: ForumCard) => (
          <Link
            key={card.id}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            to={`/forum/organization/${card.id}`}
          >
            <div
              className="relative w-full h-[250px] sm:h-[300px] bg-cover bg-center rounded-2xl p-4 flex items-end drop-shadow-lg transition hover:cursor-pointer hover:scale-105 duration-300"
              style={{
                backgroundImage: card.image
                  ? `url('${card.image.startsWith("http") ? card.image : `${HOST_API}/${card.image}`}')`
                  : undefined,
                backgroundColor: card.image ? undefined : "var(--gray-200, #e5e7eb)",
              }}
            >
              <div className="absolute inset-0 bg-black/40 rounded-2xl"></div>
              <div className="relative text-white font-bold text-lg z-10">
                {card.title}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
